// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"644bc4eb","319":"866b8006","505":"ed5040d3","774":"8033328b","787":"ac5a5245","807":"e8b8662c","858":"abaf6ecf","994":"6b6fffcc"}[chunkId] + ".chunk.js";
};